import { Stack, Typography, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';

interface PrescriptionSubStepsProps {
  careplanId: string;
  isVisible: boolean;
  data?: any;
}

const getAllSitesFromPrescriptions = (prescriptions: any) => {
  const allSites = prescriptions
    ?.map((prescription: any) =>
      prescription.sitegroupSet
        ?.map((siteGroup: any) => siteGroup?.siteSet)
        .flat()
        .sort((a: any, b: any) => a.orderRanking - b.orderRanking),
    )
    .flat();
  return allSites || [];
};

const PrescriptionSubSteps = ({ careplanId, isVisible, data }: PrescriptionSubStepsProps): JSX.Element => {
  const theme = useTheme();
  const location = useLocation();

  // Parse the URL to get the siteIdx
  const pathSegments = location.pathname.split('/');
  const prescriptionIndex = pathSegments.findIndex((segment) => segment === 'prescription');
  const siteIdx =
    prescriptionIndex !== -1 && prescriptionIndex + 1 < pathSegments.length
      ? pathSegments[prescriptionIndex + 1]
      : undefined;

  if (!isVisible) {
    return <></>;
  }

  // Flatten all sites from all site groups into a single list
  const allSites = getAllSitesFromPrescriptions(data?.prescriptionsByCareplan) || [];

  if (allSites.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No sites found
      </Typography>
    );
  }

  return (
    <>
      {allSites.map((site: any, siteIndex: number) => {
        const isActive = String(siteIndex) === (siteIdx || '0');

        return (
          <div key={site.id}>
            <Stack
              sx={{
                background: isActive ? theme.palette.action.focus : 'transparent',
                padding: '8px 16px',
              }}>
              <Typography
                variant="body1"
                color={isActive ? 'text.primary' : 'text.secondary'}
                data-testid={`prescription-substep-${site.id}${isActive ? '-active' : ''}`}
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'initial',
                }}>
                {site.treatmentSite?.treatmentSite || `Site ${siteIndex + 1}`}
              </Typography>
            </Stack>
          </div>
        );
      })}
    </>
  );
};

export default PrescriptionSubSteps;
